import React, { useEffect, useState } from "react";

import { differenceInYears, format } from "date-fns";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import { Checkbox, Paper } from "@material-ui/core";
import Button from "@material-ui/core/Button";

import {
  getNomineeList,
  hideLoader,
  saveNomineeDetails,
  showLoader,
} from "../../../../store/actions";
import CardComponent from "../../transactions/newInvestor/lib/CardComponent";
import { useNewSubscriberContext } from "../Context/NewSubsciberContext";
import {
  setNomineeDetails,
  setStatusBackToSummary,
} from "../Context/NewSubscriberAction";
import getDateFromString from "./util/getDateObjectFromString";
import { _getOptions } from "./util/getOptions";
import { FieldArray, Form, Formik, useFormikContext, useField } from "formik";
import * as Yup from "yup";
import FormTextInput from "./lib/formik/InputField";
import FormDateInput from "./lib/formik/DateField";
import FormSelectInput from "./lib/formik/inputSelectField";
import { YES } from "../../../../store/types";
import { SUCCESS_RESPONSE_CODE } from ".";

function SimpleCheckboxFormikField({ name, ...rest }) {
  const [field] = useField(name);
  const { value, ...other } = field;
  const formikContext = useFormikContext();
  const { isSubmitting: disabled } = formikContext;
  return <Checkbox checked={value} disabled={disabled} {...other} {...rest} />;
}

function NomineeSection({ name }) {
  const dispatch = useDispatch();
  const {
    nomineeDetails: ND,
    ackNumber,
    dispatch: dispatchContext,
  } = useNewSubscriberContext();
  const nomineeRelations = ND?.data?.lstRelationships;

  const { setFieldValue } = useFormikContext();
  const [field, meta] = useField(name);
  const { value: values = [] } = field;

  const total = values.reduce((acc, item) => acc + +item.share, 0);
  const isNomineeButtonDisabled = total >= 100;
  const fieldError = meta.error;
  const errorMessage =
    total > 0 && typeof fieldError === "string" ? fieldError : null;

  useEffect(() => {
    (async function () {
      const response = await dispatch(getNomineeList({ AckNumber: ackNumber }));
      dispatchContext(setNomineeDetails(response));
    })();
  }, [dispatch, ackNumber, dispatchContext]);

  return (
    <>
      <FieldArray name={name}>
        {({ remove, push }) => (
          <div>
            {values.length > 0 &&
              values.map((nominee, index) => (
                <>
                  <h5 className="m-3">Nominee {+index + 1}</h5>
                  <br />
                  <Paper className="m-1 p-3 new-investor-container">
                    <FormTextInput
                      label="Name"
                      name={`${name}.${index}.nomineeName`}
                      required
                    />
                    <FormSelectInput
                      label="Relation"
                      name={`${name}.${index}.nomineeRelation`}
                      options={_getOptions(nomineeRelations, "Id")}
                      onChange={(e) => {
                        const value = e.target.value;
                        setFieldValue(
                          `${name}.${index}.nomineeRelation`,
                          value
                        );
                      }}
                      required
                    />
                    <FormDateInput
                      label="Date Of Birth"
                      name={`${name}.${index}.nomineeDob`}
                      placeholder="Enter Date of Birth"
                      isMinorAllowed={true}
                      required
                    />
                    {+nominee.nomineeRelation === 12 && (
                      <FormTextInput
                        label="Specify Relation"
                        name={`${name}.${index}.specify`}
                        required
                      />
                    )}
                    <FormTextInput
                      label="% of Share"
                      type="number"
                      name={`${name}.${index}.share`}
                      required
                    />

                    {differenceInYears(new Date(), nominee.nomineeDob) < 18 && (
                      <FormTextInput
                        label="Guardian Name"
                        name={`${name}.${index}.guardianFirstName`}
                        required
                      />
                    )}
                  </Paper>
                  <div className="d-flex flex-row justify-content-end">
                    {values.length < 3 && index === values.length - 1 && (
                      <Button
                        onClick={() =>
                          push({
                            nomineeRelation: "",
                            nomineeName: "",
                            nomineeDob: "",
                            share: "",
                            specify: "",
                          })
                        }
                        style={{
                          color: isNomineeButtonDisabled ? "grey" : "#007ac8",
                          marginRight: "10px",
                        }}
                        disabled={isNomineeButtonDisabled}
                      >
                        + ADD NOMINEE
                      </Button>
                    )}
                    {values.length > 1 && (
                      <Button
                        style={{ color: "#c41a0b" }}
                        onClick={() => remove(index)}
                      >
                        Delete
                      </Button>
                    )}
                  </div>
                </>
              ))}
          </div>
        )}
      </FieldArray>
      {errorMessage && <div className="nps-error-message">{errorMessage}</div>}
    </>
  );
}

function NomineeDetails() {
  const dispatch = useDispatch();
  const history = useHistory();
  const {
    isBackToSummary,
    ackNumber: AckNumber,
    nomineeDetails: ND,
    accountType: AT,
    dispatch: dispatchContext,
    oldAccountType,
    personalDetails,
  } = useNewSubscriberContext();
  const [accountType] = useState(AT?.data?.AccountType || "1");
  const hasTierTwo = accountType === "2";

  const subscriberName = personalDetails?.data?.Name?.trim();

  const NominationList = ND?.data?.NominationList || [];

  const isSameAsTier1 =
    NominationList.length === 0 ||
    NominationList?.[0]?.chkNomineeSameasTire1 === YES;

  const NominationList2 = (hasTierTwo ? ND?.data?.NominationsList2 : []) || [];

  const initialValues = {
    tier1:
      NominationList?.length === 0
        ? [
            {
              nomineeName: "",
              nomineeRelation: "",
              share: "",
              nomineeDob: "",
              guardianFirstName: "",
            },
          ]
        : NominationList?.map(
            ({
              FirstName,
              RelationType,
              DateOfBirth,
              Nompercentage,
              GuardianFirstName,
              RelationTypeName,
            }) => ({
              nomineeName: FirstName,
              nomineeRelation: RelationType,
              share: Nompercentage,
              nomineeDob: getDateFromString(DateOfBirth),
              guardianFirstName: GuardianFirstName,
              ...(Number(RelationType) === 12
                ? { specify: RelationTypeName }
                : {}),
            })
          ),
    ...(hasTierTwo
      ? {
          isNomineesSameAsTier1: isSameAsTier1,
          tier2:
            NominationList2?.length === 0
              ? [
                  {
                    nomineeName: "",
                    nomineeRelation: "",
                    share: "",
                    nomineeDob: "",
                    guardianFirstName: "",
                  },
                ]
              : NominationList2?.map(
                  ({
                    Slno,
                    FirstName,
                    RelationType,
                    DateOfBirth,
                    Nompercentage,
                    GuardianFirstName,
                  }) => ({
                    nomineeName: FirstName,
                    nomineeRelation: RelationType,
                    share: Nompercentage,
                    nomineeDob: getDateFromString(DateOfBirth),
                    guardianFirstName: GuardianFirstName,
                  })
                ),
        }
      : {}),
  };

  const nomineeBaseValidation = Yup.array()
    .test("sum", "Total share should be 100", function (value) {
      if (value) {
        const sum = value.reduce((acc, curr) => acc + +curr.share, 0);
        if (sum !== 100) {
          return this.createError({
            message: `Total share should be 100${
              value.length === 0 ? "" : `, Currently ${sum}`
            }`,
          });
        }
        const valueArr = value.map(function (item) {
          return item?.nomineeName?.toLowerCase();
        });
        const isDuplicate = valueArr.some(function (item, idx) {
          return valueArr?.indexOf(item) != idx;
        });
        if (isDuplicate) {
          return this.createError({
            message: `Nominee names cannot be the same. Please enter different names.`,
          });
        }
        return true;
      }
      return true;
    })
    .of(
      Yup.object().shape({
        nomineeRelation: Yup.string().required("Relation is required"),
        nomineeName: Yup.string()
          .required("Name is required")
          .matches(/^[a-zA-Z ]{3,50}$/, "Enter a valid name")
          .test(
            "validateName",
            "Nominee Name cannot be same as Investor Name",
            function (nomineeName) {
              if (
                nomineeName?.toUpperCase() !== subscriberName?.toUpperCase()
              ) {
                return true;
              }
              return false;
            }
          ),
        nomineeDob: Yup.string()
          .required("Date of birth is required")
          .nullable(),
        share: Yup.number()
          .required("% Share of the nomination is required")
          .min(0)
          .max(100, "% share cannot be more than 100"),
        specify: Yup.string().when(
          "nomineeRelation",
          (nomineeRelation, schema) => {
            return +nomineeRelation === 12
              ? schema.required("Please specify the relation")
              : schema;
          }
        ),
        guardianFirstName: Yup.string().when(
          "nomineeDob",
          (nomineeDob, schema) => {
            return +differenceInYears(new Date(), nomineeDob) < 18
              ? schema
                  .required("Guardian Name is required")
                  .matches(/^[a-zA-Z ]{3,50}$/, "Enter a valid name")
              : schema;
          }
        ),
      })
    );
  const validationSchema = Yup.object().shape({
    tier1: nomineeBaseValidation
      .required("Atleast one nominee should be added")
      .min(1, "Atleast one nominee should be added"),
    ...(hasTierTwo
      ? {
          isNomineesSameAsTier1: Yup.boolean(),
          tier2: nomineeBaseValidation.when("isNomineesSameAsTier1", {
            is: true,
            then: (schema) => Yup.mixed().notRequired(),
            otherwise: (schema) => schema,
          }),
        }
      : {}),
  });

  const _handleSubmit = async (values) => {
    try {
      dispatch(showLoader());

      const nomineeTransformer = (
        { nomineeName, nomineeRelation, share, nomineeDob, guardianFirstName },
        index
      ) => {
        const age = differenceInYears(new Date(), nomineeDob);

        return {
          AccountType: "1",
          FirstName: nomineeName,
          RelationType: nomineeRelation,
          Age: age.toString(),
          Nompercentage: share,
          DateOfBirth: format(nomineeDob, "dd/MM/yyyy"),
          Slno: +index + 1,
          IsMajor: age >= 18 ? 1 : 0,
          ...(age < 18
            ? {
                GuardianFirstName: guardianFirstName,
              }
            : {}),
        };
      };

      const nomineeDetails = values.tier1.map(nomineeTransformer);

      const params = {
        AckNumber: AckNumber,
        chkNomineeSameasTire1: values.isNomineesSameAsTier1 ? "Y" : "N",
        NominationList: JSON.stringify(nomineeDetails).trim(),
        NominationsList2: hasTierTwo
          ? values.isNomineesSameAsTier1
            ? JSON.stringify(nomineeDetails).trim()
            : JSON.stringify(
                (values.tier2 || []).map(nomineeTransformer)
              ).trim()
          : "[]",
        AccountType: accountType,
      };
      const response = await dispatch(saveNomineeDetails(params));

      if (Number(response.statusCode) !== SUCCESS_RESPONSE_CODE) {
        throw new Error(response.message || "Error Saving Nominee Details");
      }

      const getNomineeResponse = await dispatch(getNomineeList({ AckNumber }));
      if (Number(getNomineeResponse?.statusCode) === SUCCESS_RESPONSE_CODE) {
        dispatchContext(setNomineeDetails(getNomineeResponse));
      }
      const backToSummary = [
        oldAccountType,
        isBackToSummary,
        oldAccountType === accountType,
      ].every(Boolean);

      if (backToSummary) {
        dispatchContext(setStatusBackToSummary(false));
        history.push("/nps/AddSubs/subscriber-summary");
        return;
      }

      history.push("/nps/AddSubs/bank-details");
    } catch (error) {
      console.error(error);
      alert(error);
    } finally {
      dispatch(hideLoader());
    }
  };

  const goBack = () => {
    history.push({
      pathname: "/nps/AddSubs/scheme-details",
    });
  };

  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={_handleSubmit}
      >
        {({ values, errors, setFieldValue, validateField }) => (
          <Form>
            <CardComponent title="Tier I">
              <NomineeSection name={"tier1"} />
            </CardComponent>
            {hasTierTwo && (
              <div className="container-margin">
                <div className="new-investor-card-header">
                  TIER II
                  <SimpleCheckboxFormikField
                    name={"isNomineesSameAsTier1"}
                    style={{
                      marginLeft: "30px",
                      cursor: "pointer",
                      color: "#003d7b",
                    }}
                    onChange={(event) => {
                      const { checked } = event.target;
                      setFieldValue("isNomineesSameAsTier1", checked);

                      validateField("tier2");
                    }}
                  />
                  Nominee(s) same as Tier I
                </div>
                {!values.isNomineesSameAsTier1 && (
                  <div className="new-investor-card">
                    <NomineeSection name={"tier2"} />
                  </div>
                )}
              </div>
            )}
            <div className="d-flex justify-content-center">
              <button
                className="new-investor-button"
                onClick={goBack}
                disabled={!goBack}
                style={{
                  border: "1px solid #007ac8",
                  color: "#007ac8",
                }}
              >
                Back
              </button>
              <button
                type="submit"
                className="new-investor-button new-investor-active"
              >
                Proceed
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
}

export default NomineeDetails;
